import { render, staticRenderFns } from "./Versionings.vue?vue&type=template&id=568fa016&scoped=true"
import script from "./Versionings.vue?vue&type=script&lang=js"
export * from "./Versionings.vue?vue&type=script&lang=js"
import style0 from "./Versionings.vue?vue&type=style&index=0&id=568fa016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568fa016",
  null
  
)

export default component.exports